import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "What makes Show Up different from other habit trackers?",
      answer: "Show Up focuses on simplicity and the PACT framework (Prompts, Accountability, Community, Time-based). We believe in 'showing up again' rather than overthinking your habits. It's the app that comes before traditional habits and goals."
    },
    {
      question: "What is the PACT framework for habit building?",
      answer: "PACT stands for Prompts, Accountability, Community, and Time-based commitments. This science-backed approach helps you build lasting habits by focusing on systems rather than outcomes. It's about consistent showing up, not perfect performance."
    },
    {
      question: "How does 'don't overthink it' philosophy work?",
      answer: "Most people fail at habits because they overcomplicate them. Our 'don't overthink it, show up again' approach focuses on simple, sustainable actions you can repeat daily. Small consistent actions beat grand plans every time."
    },
    {
      question: "Is Show Up really free to use?",
      answer: "Yes! Show Up is designed to be accessible to everyone. We believe that building better habits shouldn't cost money. Our core features will always remain free."
    },
    {
      question: "When will the app be available?",
      answer: "Show Up is currently in beta testing with select users. We're working hard to launch soon! Join our early access list to be among the first to try it when we launch."
    },
    {
      question: "How do I build lasting habits with Show Up?",
      answer: "Start small, show up consistently, and don't overthink it. Focus on the process of showing up rather than perfect outcomes. Our PACT framework guides you through prompts, accountability, community support, and time-based commitments."
    },
    {
      question: "Can I track multiple habits at once?",
      answer: "Yes, but we encourage starting with just 1-3 habits to avoid overwhelm. Quality over quantity - it's better to consistently show up for a few habits than to spread yourself too thin across many."
    },
    {
      question: "What does 'the app that comes before habits & goals' mean?",
      answer: "Before you set big goals or complex habit systems, you need to learn the fundamental skill of showing up consistently. Show Up teaches this foundational behavior that makes all other habits and goals possible."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Everything you need to know about Show Up and building lasting habits
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`} 
              className="bg-slate-50 rounded-lg border border-slate-200"
            >
              <AccordionTrigger className="px-6 py-4 text-left text-lg font-semibold text-slate-900 hover:text-blue-600">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 text-slate-600 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-12">
          <p className="text-slate-600">
            Still have questions? We'd love to help you get started with showing up.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;